import { useCallback, useEffect, useRef, useState } from "react";
import { classNames } from "../../../../helpers/classNames";
import useFetch from "../../../../hooks/useFetch";
import { faqList } from "../../../../services/faqService";
import { useBanner } from "../../../../providers/BannerProviders";
import Image from "../../../elements/Image";
import { removeDuplicateFromArray } from "../../../../helpers";

const FaqItem = ({ data, handleChange = () => {} }) => {
  return (
    <>
      <div className="relative bg-white rounded-xl overflow-hidden">
        <button
          type="button"
          className="w-full text-left flex items-center py-6 px-6 border-none bg-transparent"
          onClick={() => handleChange(data)}
        >
          <div className="w-full flex-grow flex-shrink">
            <h4
              className="text-xl text-chestnut-rose font-semibold !leading-tight"
              dangerouslySetInnerHTML={{ __html: data?.title }}
            />
          </div>
          <div className="w-8 h-8 flex-grow-0 flex-shrink-0 ml-auto rounded-md text-chestnut-rose transition-all duration-200 overflow-hidden flex items-center justify-center">
            <i
              className={classNames(
                "fa-regular fa-fw fa-chevron-down transition-all duration-200",
                data?.isOpen ? "-rotate-180" : ""
              )}
            ></i>
          </div>
        </button>
        <div
          className={classNames(
            "px-6 border-slate-100 overflow-hidden transition-all duration-200",
            data?.isOpen
              ? "max-h-[2000px] opacity-100 visible"
              : "max-h-0 opacity-0 invisible"
          )}
        >
          <div
            className="text-lg space-y-4 pb-6"
            dangerouslySetInnerHTML={{ __html: data?.description }}
          ></div>
        </div>
      </div>
    </>
  );
};

const SectionFaq = () => {
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
  });
  const [allFaqs, setAllFaqs] = useState({ data: [] });
  const { data: timeLineData } = useBanner();
  const applyBanner = timeLineData?.data?.find(
    (item) => item?.bannerType === "apply"
  );

  const { data: faq, isLoading: faqLoading } = useFetch({
    dependencies: ["font-faq", filters],
    fetchFunction: async () => {
      const res = await faqList({
        ...filters,
        categoryType: "faq",
        type: "general",
        sortQuery: "ordering",
        status: 1,
      });
      if (res?.docs?.status === 200) {
        return {
          ...res?.docs,
          data: res?.docs?.data?.map((item, i) => ({
            ...item,
          })),
        };
      } else {
        return [];
      }
    },
  });

  useEffect(() => {
    if (faq?.data?.length) {
      const isFirstPage = filters.page === 1;
      const newData = faq?.data?.map((item, i) => ({
        ...item,
        isOpen: isFirstPage && i === 0,
      }));
      setAllFaqs((prev) => ({
        ...faq,
        data: removeDuplicateFromArray([...prev.data, ...newData]),
      }));
    }
  }, [faq]);

  const handleChange = (data) => {
    setAllFaqs((prevFaq) => ({
      ...prevFaq,
      data: prevFaq?.data?.map((fq) =>
        fq._id === data?._id
          ? { ...fq, isOpen: !fq.isOpen }
          : { ...fq, isOpen: false }
      ),
    }));
  };

  const observer = useRef();
  const scrollContainerRef = useRef(null);

  console.log({ faq });

  const loadMoreRef = useCallback(
    (node) => {
      if (faqLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && faq?.metadata?.nextPage) {
            setFilters((prev) => ({
              ...prev,
              page: prev.page + 1,
            }));
          }
        },
        {
          root: scrollContainerRef.current, // Limit observation to the scrollable div
          rootMargin: "0px",
          threshold: 1.0,
        }
      );

      if (node) observer.current.observe(node);
    },
    [faqLoading, faq?.metadata?.nextPage]
  );

  return (
    <>
      <div className="relative py-12 px-10 lg:px-16 bg-catskill-white rounded-3xl">
        <div className="space-y-10 sm:space-y-16">
          <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold text-center">
            FAQ
          </h2>
          <div className="relative">
            {Array.isArray(allFaqs?.data) && allFaqs?.data?.length > 0 && (
              <div
                className="max-h-[500px] overflow-y-auto pr-2"
                ref={scrollContainerRef}
              >
                <div className="space-y-4">
                  {allFaqs?.data?.map((item) => (
                    <FaqItem
                      key={item._id}
                      data={item}
                      handleChange={handleChange}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        {faq?.metadata?.nextPage && <div ref={loadMoreRef} />}
      </div>
      {applyBanner?.details?.faq?.image?.url && (
        <div className="w-[350px] rounded-full overflow-hidden mx-auto relative text-center mt-4">
          <Image
            src={applyBanner?.details?.faq?.image?.url}
            effect="fade"
            className="w-full h-full object-cover"
            alt="Timeline Banner"
          />
        </div>
      )}
    </>
  );
};

export default SectionFaq;
